import React, { useState, useEffect } from "react";
import { Button, TextField, Grid, Paper, Typography } from "@material-ui/core";
import { FormWrapper } from "./styles";
import { toast } from "react-toastify";
import { config } from "../../config";

const TicketSelection = ({ onSubmit, productList }) => {
    const [tickets, setTickets] = useState([]);

    useEffect(() => {
        if (productList.length > 0) {
            setTickets(productList.map((p) => ({ ...p, quantity: 0 })));
        }
    }, [productList]);

    const handleQuantityChange = (ticketId, quantity) => {
        if (parseInt(quantity) === parseInt(config.TICKET_LIMIT)) return;
        setTickets((prev) =>
            prev.map((ticket) => {
                return ticket.id === ticketId ? { ...ticket, quantity: parseInt(quantity, 10) || 0 } : ticket;
            })
        );
    };

    const handleSubmit = () => {
        const selectedTickets = tickets.filter((ticket) => ticket.quantity > 0);
        if (selectedTickets.length === 0) {
            toast.warn("Selecione ao menos um ingresso.");
            return;
        }
        onSubmit(selectedTickets);
    };

    return (
        <FormWrapper>
            <Grid container spacing={3}>
                {tickets.map((ticket) => (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            style={{
                                padding: "30px",
                                display: "flex",
                                flexDirection: "column",
                                borderRadius: "5px",
                                boxShadow: "0px 30px 40px -20px #6a7785",
                                margin: "10px",
                                borderTop: "3px solid #007bff",
                            }}
                        >
                            <Typography variant="h6">{ticket.product.name}</Typography>
                            <Typography variant="body2">Preço: R$ {ticket.unit_amount / 100}</Typography>
                            <TextField
                                type="number"
                                label="Quantidade"
                                value={ticket.quantity || 0}
                                onChange={(e) => handleQuantityChange(ticket.id, e.target.value)}
                                fullWidth
                                style={{ marginTop: "10px" }}
                            />
                        </Paper>
                    </Grid>
                ))}
            </Grid>
            <Button variant="contained" color="primary" onClick={handleSubmit} style={{ marginTop: "20px" }}>
                Continuar para o Pagamento
            </Button>
        </FormWrapper>
    );
};

export default TicketSelection;
